import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Mail, ArrowRight, Tag, AlertCircle, Lightbulb } from "lucide-react"

export function EmailAnalysisDemo() {
  return (
    <div className="flex flex-col items-center gap-4 lg:flex-row lg:gap-6">
      {/* Email Input */}
      <Card className="w-full bg-card p-4 lg:w-80 lg:p-5">
        <div className="mb-3 flex items-center gap-2">
          <Mail className="text-primary h-5 w-5" />
          <span className="text-muted-foreground text-sm">Новое обращение</span>
        </div>
        <div className="bg-muted/50 rounded-lg p-3">
          <p className="text-foreground text-sm leading-relaxed">
            "Не могу оплатить картой, пишет ошибку. Пытаюсь уже 2 часа, ничего не получается. Срочно нужно оформить
            заказ!"
          </p>
          <div className="text-muted-foreground mt-2 text-xs">От: client@company.com</div>
        </div>
      </Card>

      {/* Arrow */}
      <div className="flex shrink-0 items-center justify-center">
        <ArrowRight className="text-primary h-6 w-6 rotate-90 lg:rotate-0" />
      </div>

      {/* Analysis Result */}
      <Card className="w-full flex-1 border-primary/20 bg-card p-4 lg:p-5">
        <div className="mb-3 flex items-center gap-2">
          <div className="bg-primary/10 flex h-8 w-8 items-center justify-center rounded-full">
            <Lightbulb className="text-primary h-4 w-4" />
          </div>
          <span className="text-foreground font-medium">Результат анализа</span>
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <Tag className="text-muted-foreground h-4 w-4" />
            <span className="text-muted-foreground text-sm">Категория:</span>
            <Badge>Оплата и биллинг</Badge>
          </div>
          <div className="flex items-center gap-2">
            <AlertCircle className="text-destructive h-4 w-4" />
            <span className="text-muted-foreground text-sm">Критичность:</span>
            <Badge variant="destructive">Критический</Badge>
          </div>
          <div className="bg-muted/50 rounded-lg p-3">
            <p className="text-muted-foreground text-sm">
              Связано с 11 другими обращениями о проблемах с оплатой за последние 24 часа
            </p>
          </div>
        </div>
      </Card>
    </div>
  )
}
